import type { RawTab } from '../../types';

import * as shared from './shared';

export const MenuTab: RawTab = {
  id: shared.id,

  link: shared.link,

  iconSource: require('./icons/fhs-menu-inactive.png'),
  iconActiveSource: require('./icons/fhs-menu-active.png'),

  text: {
    en: 'Order',
    fr: 'Commander',
  },
};
